import React from 'react';
import ReactDOM from 'react-dom';

import EntryWrapper from 'src/EntryWrapper';
import { FaqOrder } from '../components/faq/FaqOrder';

window.addEventListener('load', () => {
  const rootElement = document.getElementById('faqOrder-root');

  if (rootElement) {
    ReactDOM.render(
        <EntryWrapper>
          <FaqOrder />
        </EntryWrapper>,
        rootElement
    );
  }
});
